import { PencilIcon } from "@heroicons/react/24/outline";
import { IconButton } from "../../../../../../../components/ui/IconButton";
import { Modal } from "../../../../../../../components/ui/Modal";
import useUser from "../../../../../../../hooks/useUser";
import EditOffer from "../../../../../../Offer/pages/List/components/EditOffer";

const Actions = (props = {}) => {
  const { id: offerId, values, artworkId } = props;
  const { hasPermission } = useUser();
  const modalProps = {
    body: EditOffer,
    closeOnBackdrop: false,
    hideCloseButton: false,
    scale: "lg",
    offer: { artworkId, ...values },
  };

  if (!offerId) return null;

  return (
    <div className="user-list-actions flex text-right text-sm font-medium">
      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4">
        <Modal {...modalProps}>
          {hasPermission("UPDATE_OFFER") && (
            <IconButton variant="clean" title="Edit Offer">
              <PencilIcon className={`h-4 w-4 cursor-pointer text-gray-400`} />
            </IconButton>
          )}
        </Modal>
      </div>
    </div>
  );
};

export default Actions;
